import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//     value: false
// }

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        userAuth: false,
    },
    
    //a reducer is a function that takes in the current state of an application and an action as arguments,
    //and returns a new state based on the action - blends them together.
    reducers: {
        setAuth: (state, action) =>{
            state.userAuth = action.payload;
            //state.value = initialState that will be changed through the action.payload which will be received from
            //external components or changes via the action.payload.
        }
    }
});

//Export all the actions in the reducers - by name.
export const {setAuth} = authSlice.actions;
//Export the current state
export const authState = (state) => state.userAuth.userAuth;
//Export the slice.
export default authSlice.reducer;